export default __webpack_public_path__ + "static/media/buildSmarter.66953a77.png";